module.exports = __webpack_public_path__ + "img/waitServerE.b74d681d.png";